<template>
  <footer class="footer" id="pageFooter">
    <div class="footer-wave">
      <div class="e_image-1 s_img response-transition">
        <svg class="waves" viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto">
          <defs>
            <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"></path>
          </defs>
          <g class="parallax">
            <use xlink:href="#gentle-wave" x="48" y="7" fill="var(--o)"></use>
          </g>
        </svg>
      </div>
    </div>
    <div class="footer-wrapper">
      <div class="footer-content">
        <div class="footer-inner">
          <div class="footer-logo">
            <img src="../assets/footer/footer-logo.png" />
          </div>
          <div class="footer-tel-wrap flex">
            <div class="footer-tel-item">
              <div class="footer-tel-title">官方加盟热线：</div>
              <a href="tel:4006600326" class="footer-tel-value">400-6600-326</a>
            </div>
            <div class="footer-tel-item">
              <div class="footer-tel-title">股票代码：</div>
              <div class="footer-tel-value">872940</div>
            </div>
          </div>
          <div class="footer-tel-wrap flex">
            <div class="footer-tel-item">
              <div class="footer-tel-title">官方网站：</div>
              <div class="footer-tel-value">www.klfspp.com</div>
            </div>
          </div>
          <div class="footer-text-wrap">
            <div class="footer-text-title">总部地址：</div>
            <div class="footer-text-value">厦门市思明区台北路1号之一23层 (海西金谷广场T1)</div>
          </div>
          <div class="footer-text-wrap">
            <div class="footer-text-title">快乐番薯智能产业园地址：</div>
            <div class="footer-text-value">厦门市海沧区绿石渡路8号</div>
          </div>
<!--          <div class="footer-text-wrap">-->
<!--            <div class="footer-text-title">官方邮箱：</div>-->
<!--            <div class="footer-text-value">pinpai01@klfspp.com</div>-->
<!--          </div>-->
          <div class="ewm-wrap">
            <div class="ewm-list flex">
              <div class="ewm-item">
                <img src="../assets/footer/kefu-ewm.png" alt="">
                <p>官方客服</p>
                <p>扫描添加咨询加盟</p>
              </div>
              <div class="ewm-item">
                <img src="../assets/footer/wb.png" alt="">
                <p>官方微博</p>
                <p>扫描关注官方微博</p>
              </div>
              <div class="ewm-item">
                <img src="../assets/footer/gzh.png" alt="">
                <p>微信公众号</p>
                <p>扫描关注品牌公众号</p>
              </div>
              <div class="ewm-item">
                <img src="../assets/footer/xhs.png" alt="">
                <p>小红书</p>
                <p>扫描关注小红书</p>
              </div>
              <div class="ewm-item">
                <img src="../assets/footer/wx-video.png" alt="">
                <p>品牌视频号</p>
                <p>扫描关注品牌视频号</p>
              </div>
              <div class="ewm-item">
                <img src="../assets/footer/dy.png" alt="">
                <p>抖音官方号</p>
                <p>扫描关注官方抖音</p>
              </div>
            </div>
          </div>
        </div>
        <div class="klfs-doll">
          <img src="../assets/footer/footer-doll.png" />
        </div>
      </div>
      <div class="beian-view">
        <p>厦门快乐番薯股份有限公司 闽ICP备16039111号-1</p>
        <p>市场有风险，投资需谨慎</p>
      </div>
    </div>
  </footer>
</template>
<script>
	export default {
    name: 'KlfsFooter',
		data() {
			return {

			}
		},
		created() {

		},
    mounted() {

    },

		methods: {

		}
	}
</script>
<style scoped>
.footer-wrapper {
  padding: 60px 20px 20px;
  background-color: #fd8103;
  color: #fff;
}
.footer-content {
  max-width: 1400px;
  margin: 0 auto;
  background-image: url("../assets/footer/funso.png");
  background-repeat: no-repeat;
  background-position: top right;
  position: relative;
}
.footer-inner {
  position: relative;
  z-index: 1;
}
.klfs-doll {
  position: absolute;
  bottom: 20px;
  right: 20px;
  z-index: 0;
}
.footer-logo {
  margin-bottom: 50px;
}
.footer-tel-wrap {
  font-weight: bold;
  margin-bottom: 20px;
}
.footer-tel-item {
  line-height: 1.2;
  margin-right: 130px;
}
.footer-tel-wrap .footer-tel-item:last-child {
  margin-right: 0;
}
.footer-tel-title {
  font-size: 25px;
}
.footer-tel-value {
  font-size: 40px;
}
.footer-text-wrap {
  font-size: 16px;
  margin-bottom: 10px;
}

.ewm-wrap {
  margin-top: 60px;
}
.ewm-item {
  text-align: center;
  margin-right: 40px;
}
.ewm-item img {
  width: 110px;
  margin-bottom: 18px;
}
.ewm-wrap .ewm-item:last-child {
  margin-right: 0;
}
.beian-view {
  text-align: center;
  font-size: 14px;
  margin-top: 70px;
}

/* 波浪动画 */
.footer-wave {
  height: 60px;
  //margin-top: -60px;
}
.waves {
  position: relative;
  width: 100%;
  height: 60px;
  min-height: 60px;
}
.parallax > use:nth-child(1) {
  animation-delay: -2s;
  animation-duration: 7s;
}
.parallax > use {
  animation: 25s cubic-bezier(0.55, 0.5, 0.45, 0.5) 0s infinite normal none running move-wave;
}
@keyframes move-wave {
  0% {
    transform: translate3d(-90px, 0px, 0px);
  }
  100% {
    transform: translate3d(85px, 0px, 0px);
  }
}
/* 波浪动画 */

.footer-text-title {
  font-size: 14px;
}

@media screen and (max-width: 768px) {
  .footer-wrapper {
    padding-top: 40px;
  }
  .footer-content {
    background-size: 100%;
    background-position: 0 30px;
  }
  .footer-tel-title {
    font-size: 12px;
  }
  .footer-tel-value {
    font-size: 18px;
  }
  .footer-text-wrap {
    font-size: 12px;
  }
  .ewm-wrap {
    margin-top: 20px;
  }
  .ewm-list {
    flex-wrap: wrap;
    margin: 0 -5px;
  }
  .ewm-item {
    width: 33.33%;
    font-size: 12px;
    padding: 0 5px;
    margin-right: 0;
    margin-bottom: 20px;
  }
  .ewm-item img {
    display: block;
    width: 100%;
  }
  .klfs-doll {
    width: 50%;
    bottom: -100px;
    right: 0;
  }
  .klfs-doll img {
    display: block;
    width: 100%;
  }
  .beian-view {
    margin-top: 100px;
  }
}
</style>